<script setup lang="ts">
import { selectProps } from 'naive-ui';

const props = defineProps(selectProps);
</script>

<template>
  <n-select v-bind="props" />
</template>
